import {
  createEffect,
  ofType,
  registerEffects,
  removeEffects,
  tapResult,
} from '@ngneat/effects';

import { saveUserPreferences } from './user-preferences.actions';
import { updateUserPreferences } from './user-preferences.repository';

const saveUserPreferences$ = createEffect((actions) =>
  actions.pipe(
    ofType(saveUserPreferences),
    tapResult(({ preferences }) => {
      updateUserPreferences(preferences);
    })
  )
);

const effects = [saveUserPreferences$];

export function registerUserPreferencesEffects() {
  registerEffects(effects);
}

export function deregisterUserPreferencesEffects() {
  removeEffects(effects);
}
